enum SearchedItemsCodeEnum {
  NOT_FOUND = '10'
}

export default SearchedItemsCodeEnum;
